import React from 'react'
import {Stake} from "./Stake";
import {Unstake} from "./Unstake";
import {Reward} from "./Reward";
import {InviteReward} from "./InviteReward";
import styles from './Forms.module.sass';


export function Forms({ balances }) {
    return (
        <div className={styles.forms_grid}>
            <Stake balances={balances} />
            <Unstake balances={balances} />
            <Reward balances={balances} />
            <InviteReward balances={balances}/>
        </div>
    )
}
